export default __webpack_public_path__ + "static/media/feature_3@2x.5ea079cd.png";